module.exports = __webpack_public_path__ + "img/icbc.499cf48e.png";